import { Box, Icon, Tooltip } from "@outschool/backpack";
import { faCreditCard } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

export default function PayAsYouGoTag({
  showToolTip = false,
  canPayLater = false
}) {
  const { t } = useTranslation(
    "client\\components\\enrolling\\enrollmentForm\\PayAsYouGoTag"
  );

  const ChargeWeeklyTag = (
    <Box
      sx={{
        backgroundColor: "warning.400",
        fontWeight: "fontWeightBold",
        padding: "1px 4px",
        borderRadius: "4px",
        fontSize: "medium"
      }}
    >
      <Icon
        icon={faCreditCard}
        sx={{
          width: "1.25em",
          marginRight: "0.5em"
        }}
      />
      {t`Charged weekly`}
    </Box>
  );

  return (
    <>
      {showToolTip ? (
        <Tooltip
          title={
            canPayLater
              ? t(
                  "Enroll now and pay weekly. Your future meetings will be automatically charged weekly on Sundays before the class date."
                )
              : t(
                  "Enroll now, pay weekly. Pay the first-class fee, \
and all future meetings are automatically charged weekly on \
Sundays before the class date."
                )
          }
        >
          {ChargeWeeklyTag}
        </Tooltip>
      ) : (
        ChargeWeeklyTag
      )}
    </>
  );
}
